import { gql } from '@apollo/client';
export const StatPermissionsEmployee = gql `
    query StatPermissionsEmployee($siteSetId: SiteSetId!, $employeeId: EmployeeId!) {
        staffhours {
            management {
                schedules(siteSetId: $siteSetId, employeeId: $employeeId) {
                    canView
                    canEdit
                }

                staffAttendance {
                    employee(siteSetId: $siteSetId, employeeId: $employeeId) {
                        canView
                    }
                }
            }
        }
    }
`;
